import { PlaceAutocompleteResponseData } from '@googlemaps/google-maps-services-js';

export const placeAutocompleteName = 'place_autocomplete';
export type PlaceAutocompleteRequestData =
  GeocodeRequest | AddressRequest | PlaceDetailsRequest;
export type PlaceAutocompleteFnResponse = PlaceAutocompleteResponseData;

/** Geocode Autocomplete */
export type GeocodeRequest = {
  type: 'geocode';
  query: string;
  lat: number;
  lng: number;
  session?: never;
};
export type GeocodeAutocompleteResponse = PlaceAutocompleteResponseData;

/** Address Autocomplete */
export type AddressRequest = {
  type: 'address';
  query: string;
  session: string;
};
export type AddressAutocompleteResponse = {
  suggestions: {
    placePrediction: { placeId: string; text: { text: string } };
  }[];
};

/** Place Details*/
export type PlaceDetailsRequest = {
  type: 'place';
  placeId: string;
  session: string;
};
export type PlaceDetailsResponse = {
  address: string;
  unit_number: string;
  city: string;
  state: string;
  country: string;
  postal_code: string;
  formatted_address: string;
};
